// Fetches a component partial from a component's render data.
const _ = require('lodash');

module.exports = function getComponent(component) {
  if (_.isString(component)) {
    return `${component}/component`;
  }

  return `${component.type}/component`;
};



// WEBPACK FOOTER //
// ./~/unicorn/shared/helpers/getComponent.js